import { useSelector } from 'react-redux';

// Design system
import { Message } from 'jl-design-system/components/message/Message';

// Config
import clearpayConnectMessageState from './ClearpayConnectMessage.state';

// Components
import Container from '../container';

const ClearpayConnectMessage = () => {
  const { showMessage } = useSelector(clearpayConnectMessageState);

  return showMessage && (
    <Container marginBottom="2">
      <Message
        body="Please consider using an alternative payment method."
        dataId="unable-connect-clearpay"
        scrollToMessageOnMount
        title="Sorry, we've been unable to connect to Clearpay"
        type="error"
      />
    </Container>
  );
};

export default ClearpayConnectMessage;
